"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsIndexPage = SettingsIndexPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var loader_1 = require("../../components/loader");
var routes_1 = require("../../constants/routes");
var permission_1 = require("../../features/apis/permission");
var hooks_1 = require("../../store/hooks");
/** `/settings` lands on the first tab the user can open. */
function SettingsIndexPage() {
    var _a, _b, _c;
    var authUser = (0, hooks_1.useAppSelector)(function (state) { return state.user.user; });
    // Not useHasPermission: it reads false while loading, which would send billing users to Permissions.
    var _d = (0, permission_1.useGetEffectivePermissionsQuery)("".concat((_a = authUser === null || authUser === void 0 ? void 0 : authUser._uid) !== null && _a !== void 0 ? _a : "", ":").concat((_b = authUser === null || authUser === void 0 ? void 0 : authUser.client) !== null && _b !== void 0 ? _b : ""), { skip: !authUser }), currentData = _d.currentData, isFetching = _d.isFetching;
    if (isFetching || !currentData) {
        return (0, jsx_runtime_1.jsx)(loader_1.Loader, { label: "Loading settings" });
    }
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: ((_c = currentData.content) === null || _c === void 0 ? void 0 : _c.manage_billing) ? routes_1.ROUTES.BILLING_SETTINGS : routes_1.ROUTES.PERMISSIONS_SETTINGS, replace: true });
}
